module.exports = __webpack_public_path__ + "static/circle3-120c18005f2e7ac37ee4924478ea073f.png";